import { DailySchedule } from '../schema/daily-schedule.schema';
import { DailyScheduleValidator } from '../validators/index';

export const isDailySchedule = (value: unknown): value is DailySchedule =>
  DailyScheduleValidator.Check(value);
